import Balance from "ui/wallet/component/display/Balance/Balance";
import { BalanceProps, FormatOptions } from "ui/wallet/component/display/Balance/Balance.types";
import clsx from "clsx";
import usePointsBalance from "./hooks/usePointsBalance";
import { default as config } from "common/config/config";
import { ModalProps, Row, Typography } from "@commonlibs";
import { spacing } from "ui/config/theme/spacing/spacing";
import useUserState from "ui/adapter/state/useUserState";
import EditIcon from "ui/common/icons/EditIcon";
import { RoleType } from "common/models/role/Role";
import { ModalWithId, useModal } from "commonlibs/react-components-core";
import { SendPointsToUserModalProps } from "ui/point/containers/SendPointsToUserModal/SendPointsToUserModal.types";

export interface PointsBalanceTextProps extends Omit<BalanceProps, "units" | "balance"> {
    className?: string;
    style?: React.CSSProperties;
    showUnits?: boolean;
    balance: string | undefined;
    text: string;
    modal: ModalWithId<ModalProps & SendPointsToUserModalProps>;
    gab?: string;
    formatter?: FormatOptions;
}

export default function PointsBalanceText({
    className,
    showUnits,
    balance: balanceProp = "0",
    isLoading: isLoadingProp,
    text: textProp,
    modal,
    gab,
    formatter,
    ...rest
}: PointsBalanceTextProps) {
    const props = usePointsBalance({ balance: balanceProp, isLoading: isLoadingProp });
    const { showModal } = useModal();
    const { selectedRole } = useUserState();

    return (
        <Row justifyContent="flex-start" gap={gab ? gab : spacing["2.5"]}>
            <Balance
                className={clsx("points-balance", className)}
                units={showUnits ? config.tokenNames.points : undefined}
                formatter={formatter}
                {...props}
                {...rest}
            />
            <Typography variant={rest.variant}>{textProp}</Typography>
            {selectedRole?.roleType === RoleType.ORGANIZATION_OWNER ? (
                <EditIcon css={{ cursor: "pointer" }} fontSize={20} onClick={() => showModal(modal)} />
            ) : null}
        </Row>
    );
}
